import { useEffect, useState } from "react";

export const useOverlayNotification = (id: string) => {
  const [message, setMessage] = useState<string | React.ReactNode>("");

  useEffect(() => {
    const handleNotification = (event: CustomEvent<string>) => {
      setMessage(event.detail);
    };

    window.addEventListener(id, handleNotification as EventListener);
    return () => window.removeEventListener(id, handleNotification as EventListener);
  }, [id]);

  return { message };
};
